var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"发送邮件预览","close-on-click-modal":false,"visible":_vm.dialogVisible,"width":"1200px","center":""},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"content"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }